import React, { useState } from "react";
import { motion } from "framer-motion";
import "../GuidedTour.css";

export default function Step1_CreateClass({ onComplete }) {
  const [className, setClassName] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");

    if (!className.trim()) {
      setError("Please enter a class name");
      return;
    }

    // Instant completion - no API call
    onComplete(className.trim());
  };

  return (
    <div className="tour-step-container">
      <motion.div
        className="tour-step-full-card"
        initial={{ scale: 0.95 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.2 }}
      >
        {/* Step Header */}
        <div className="tour-step-header">
          <div className="tour-step-icon-large">
            <i className="fa-solid fa-school"></i>
          </div>
          <h2 className="tour-step-title">Create a Class</h2>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="tour-step-form">
          <div className="demo-form-group">
            <label htmlFor="className">
              <i className="fa-solid fa-pencil"></i>
              Class Name
              <span className="required">*</span>
            </label>
            <input
              type="text"
              id="className"
              name="className"
              placeholder="e.g., Science 10A, Math Advanced, Biology 101"
              value={className}
              onChange={(e) => setClassName(e.target.value)}
              required
              className="demo-input"
              autoFocus
            />
            <small className="input-hint">
              <i className="fa-solid fa-lightbulb"></i>
              Choose a name that helps you identify this class easily
            </small>
          </div>

          {/* Error Message */}
          {error && (
            <div className="demo-error">
              <i className="fa-solid fa-exclamation-circle"></i>
              {error}
            </div>
          )}

          {/* Submit Button */}
          <div className="demo-form-actions">
            <button type="submit" className="demo-submit-btn">
              <i className="fa-solid fa-circle-chevron-right"></i>
              Next
            </button>
          </div>
        </form>
      </motion.div>
    </div>
  );
}
